// extracted by css-extract-rspack-plugin
export default {"menuButton":"CLIModePicker-module__menuButton__kGFf5","buttonLabel":"CLIModePicker-module__buttonLabel__fQIqD","compactIcon":"CLIModePicker-module__compactIcon__HdpcW"};